// Simple session token store that provides a promise-based approach to handle token availability.

let sessionTokenResolver: (sessionToken: string) => void;

export const sessionTokenPromise = new Promise<string>((resolve) => {
  sessionTokenResolver = resolve;
});

export function setSessionToken(sessionToken: string): void {
  sessionTokenResolver(sessionToken);
}
